<template>
  <div class="portfolio-page">
    <NavBar />
    <div class = "portfolio-container">
        <div class = "project-card" v-for="project in projects" :key="project.id" @click="openProject(project.link)">
          <div class = "project-image" @click="openProject(project.link)">
            <img :src="project.image" :alt="project.title + ' image'" class="image-item">
          </div>  
          <div class="project-title">
            <span @click="openProject(project.link)" class="title-item">{{ project.title }}</span>
          </div>
          <div class="project-tech-stack">
            <div class="tech-items">
              <span v-for="tech in project.techStack" :key="tech" class="tech-item">{{ tech }}</span>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'PortfolioPage',
    data() {
      return {
        projects: [
            // {
            //   id: 1,
            //   title: 'QuickConnect', 
            //   image: '/quickconnect.png', 
            //   link: 'https://github.com/waquas9248/QuickConnect',
            //   techStack: ['Python', 'Django ORM', 'Vue.js', 'MySQL']
            // },
            {
              id: 2,
              title: 'Ticketing App',
              image: '/movietheater.png',
              link: 'https://github.com/waquas9248/MovieTheaterSystem',
              techStack: ['C#', '.NET', 'SQL Server']
            },    
            {
              id: 3,
              title: 'Student Hub',
              image: '/studhub.png',
              link: 'https://github.com/waquas9248/StudentHub',
              techStack: ['Spring', 'React', 'PostgreSQL']
            },        
            {
              id: 8,
              title: 'Custom OCR',
              image: '/ocr.png',
              link: 'https://github.com/waquas9248/Indoor-OCR',
              techStack: ['PyTorch', 'React Native', 'Firebase']
            },

            {
              id: 6,
              title: 'Avatar',
              image: '/avatar.png',
              link: 'https://github.com/3C-SCSU/Avatar',
              techStack: ['Python', 'PyTorch']
            },
            {
              id: 7,
              title: 'Dial AI',
              image: '/dial-ai.png',
              link: 'https://devpost.com/software/dial-ai',
              techStack: ['Python', 'Voice AI']
            },
            {
              id: 4,
              title: 'Image Classifier',
              image: '/bdo.png',
              link: 'https://github.com/waquas9248/Big-Data-Organization',
              techStack: ['Python', 'PySpark', 'Kubernetes']
            },
            {
              id: 9,
              title: 'Product Recommender',
              image: '/amazon.png',
              link: 'https://github.com/waquas9248/ProductRecommender',
              techStack: ['scikit-learn', 'pandas', 'NumPy']
            },            {
              id: 5,
              title: 'Fraud Classifier',
              image: '/dm.png',
              link: 'https://github.com/waquas9248/SE512',
              techStack: ['Python', 'scikit-learn', 'Jupyter']
            }
        ]
      };
    },
    methods: {
      openProject(url) {
        window.open(url, '_blank');
      }
    }
  }
</script>

<style scoped>

  /* Make the overall page fill the viewport,
    with the navbar at top and container filling the rest */
    .portfolio-page {
    display: flex;
    flex-direction: column;
    height: 100vh; 
    overflow: hidden;
  }

  /* The container fills remaining space below navbar */
  .portfolio-container {
    flex: 1;
    display: grid;
    grid-template-columns: repeat(4, 1fr);  /* 4 columns */
    grid-template-rows: 1fr 1fr;              /* 2 rows, each gets 50% of available height */
    gap: 10px;
    padding-top: 20px;                            
    padding-bottom: 20px;
    padding-left: 0px;
    padding-right: 20px;
    margin: 0;
    overflow: hidden;
  }

  /* Each card fills its grid cell */
  .project-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 0; 
    padding: 10px;
    margin: 10px;
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    cursor: pointer;
  }

  /* Internal layout: 60% image, 20% title, 20% tech stack */
  .project-image {
    flex: 0 0 60%;
    display: flex;
    margin: 0;
    overflow: hidden; 
  }

  .project-image img {
    width: 100%;
    height: auto;
    object-fit: contain;
    border-radius: 5px;
  }

  .project-title {
    flex: 0 0 10%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 5px;
    margin-top: 5px;
    overflow: hidden; 
  }

  .title-item{
    font-size: clamp(0.8rem, 1vw, 1rem);
    margin: 0;
  }

  .project-tech-stack {
    flex: 0 0 30%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 5px;
    margin: 0;
    overflow: hidden; 
  }
  /* Media query for tablets and small laptops */
  /* @media (max-width: 1024px) {
    .portfolio-container {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(4, 1fr);  
      gap: 15px;
      padding: 15px;
    }
  } */

  /* Media query for mobile devices */
  /* @media (max-width: 600px) {
    .portfolio-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      padding: 20px;
      overflow-y: auto;
    }
  } */

  .project-image :hover{
    cursor: pointer;
  }

  .project-card:hover .project-title {
    color: #007BFF;
    transition: color 0.2s ease; /* Smooth background transition */
  }

  .tech-items {
    display: flex;
    flex-wrap: wrap; /* Allow items to wrap to the next line */
    gap: 8px; /* Add space between tech items */
    margin: 5px;
  }

  .tech-item {
    background-color: #f3f4f6; /* Light background for contrast */
    color: #333; /* Dark text color */
    border-radius: 4px; /* Rounded corners for modern look */
    padding: 4px 10px; /* Padding for spacing inside the tag */
    font-size: clamp(0.6rem, 0.8vw, 1rem);
    line-height: 1;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
    cursor: default; /* No pointer cursor, as it's not clickable */
  }

  /*--------MOBILE------------*/
  @media screen and (max-width: 745px) {

    .portfolio-container {
      margin: 0;
      display: block;
      width: 100%;
      overflow-y: auto;
      padding-left: 20px;

    }

    .project-card{
      display: block;
      width: 100%;
      margin: 5px;
    }
  }
  /* .project-title:hover {
    color: #007BFF;
    cursor: pointer;
   
  } */

  /* .view-button {
    width: 100%;
    padding: 10px;
    background-color: #007BFF;
    color: white;
    border: none;
    border-radius: 0 0 10px 10px; 
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  .view-button:hover {
    background-color: #0056b3;
  }

  .fas {  
    margin-left: 5px;
  } */
</style>
